import { usePostHog } from "posthog-js/react"
import { POSTHOG_FEATURES } from "../constants/feature-flags"
import { useAuthControllerCurrentUserQuery } from "../api/authApi"

interface SystemBannerResult {
  enabled: boolean
  payload?: unknown
}

/**
 * Custom hook for system notification feature flag
 *
 * This hook returns both the enabled state and payload for system notifications
 *
 * @returns SystemBannerResult - object with enabled boolean and payload value
 */
export const useSystemBanner = (): SystemBannerResult => {
  const posthog = usePostHog()
  const { data: currentUser } = useAuthControllerCurrentUserQuery()

  const payload = posthog?.getFeatureFlagPayload(POSTHOG_FEATURES.SYSTEM_BANNER)

  if (
    (payload as Record<string, unknown>)?.override_for_super_admin &&
    currentUser?.user.isSuperAdmin
  ) {
    return {
      enabled: false,
    }
  }

  const enabled =
    posthog?.isFeatureEnabled(POSTHOG_FEATURES.SYSTEM_BANNER) ?? false

  return {
    enabled,
    payload,
  }
}

export default useSystemBanner
